// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kv-6";
export var emphasizeQuantity = "_kv-3";
export var flatBottomCorners = "_kv-5";
export var productImage = "_kv-0";
export var quantityContainer = "_kv-2";
export var tooltip = "_kv-1";
export var wrapAndEllipsesOverflow = "_kv-4";